import { GREY_1000 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

/**
 * @deprecated Use css in favor of this component
 */
const Link = styled.a`
  text-decoration: none;
  color: ${GREY_1000};
  cursor: pointer;

  &:hover {
    color: ${GREY_1000};
  }
`;

export default Link;
